<template>
    <v-app :style="{fontFamily: fontFamily, color: contentColor}">
        <!-- app bar -->
        <v-app-bar
            app
            dark
            :color="bannerColor"
            :src="(ifBanner)?banner:''"
            :height="height"
            elevate-on-scroll
        >
            <template v-slot:img="{ props }">
                <v-img
                    v-bind="props"
                    :gradient="`to top right, ${bannerColor}96, ${bannerColor}59`"
                ></v-img>
            </template>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <img :src="logo" alt="Logo">
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <template v-slot:extension>
                <v-tabs
                    slider-size="5"
                    :background-color="navColor"
                    centered
                    show-arrows
                >
                    <template >
                        <div class="d-flex justify-center align-center" >
                            <h3 :style="`color:${textnavColor}`">{{ category_name }}</h3>
                        </div>
                    </template>
                </v-tabs>
            </template>
        </v-app-bar>
        <!-- end app bar -->
        <!-- app main -->
        <v-main class="bg" :style="(ifBody)?`background-image: url(${body})`:`background-color: ${bodyColor}`">
        <slot />
        </v-main>
        <!-- end app main -->
    </v-app>
</template>
<script>
import Countdown from 'vuejs-countdown'
export default {
    components: { Countdown },
    data() {
        return {
            bannerColor: '',
            textbannerColor: '',
            navColor: '',
            textnavColor: '',
            ifBanner: true,
            logo: '',
            banner: '',
            contentColor: '',
            titleColor: '',
            titleCardColor: '',
            fontFamily: '',
            tmpFontFamily: '',
            ifBody: false,
            bodyColor: '',
            prodId: '',
            bannerProd: '',
            nameProd: '',
            descriptionProd: '',
            quantity: 1,
            stock: 100,
            txt: '',
            tempMode: 'order_auto',
            currentTime: null,
            showTime: false,
        }
    },
    props: ['slug', 'category_name'],
    mounted() {
        this.getSettingStore()
    },
    methods: {
        scrollTo(to) {
            this.$vuetify.goTo(to, {duration: 1000, offset: 20, easing: 'easeInOutCubic'})
        },
        /**
         * main store
         */
        async getSettingStore() {
            const formData = new FormData
            // formData.append('slug', this.slug)
            // formData.append('_method', 'POST')
            await axios.get(`/store-data/${this.slug}`)
            .then(response => {
                // console.log(response)
                if (response.data[0]) {
                    this.bannerColor = response.data[0].banner_color
                    this.textbannerColor = response.data[0].textbanner_color
                    this.navColor = response.data[0].nav_color
                    this.textnavColor = response.data[0].textnav_color
                    this.ifBanner = response.data[0].if_banner
                    this.logo = response.data[0].logo
                    this.banner = response.data[0].banner
                    this.btnColor = response.data[0].btn_color
                    this.textbtnColor = response.data[0].textbtn_color
                    this.contentColor = response.data[0].content_color
                    this.titleColor = response.data[0].title_color
                    this.titleCardColor = response.data[0].titlecard_color
                    this.priceColor = response.data[0].price_color
                    this.fontFamily = response.data[0].font_family
                    this.consultWps = (response.data[0].consult_wps)?true:false
                    this.ifBody = response.data[0].if_body
                    this.bodyColor = response.data[0].body_color
                    this.body = response.data[0].body
                    this.emergency = (response.data[0].emergency)?true:false
                    const font = (response.data[0].font_family).replace(/[^a-zA-Z ]/g, "")
                    this.tmpFontFamily = font.replace(/\s+/g, '-').toLowerCase()
                    this.money = response.data[0].money
                }
                
            })
            .catch(error => {
                // console.log(error)
                if (error.response.status == 404 || error.response.status == 500) {
                    this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                }
            })
        },
    },
    computed: {
        height () {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs': return 80
                case 'sm': return 100
                case 'md': return 120
                case 'lg': return 120
                case 'xl': return 120
            }
        },
    },
}
</script>
